import { useState, useEffect, useRef } from 'react';

export const useIntersectionObserver = () => {
  const [currentSection, setCurrentSection] = useState('hero');
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            // Clear any existing timeout
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current);
            }
            
            // Debounce the section change
            timeoutRef.current = setTimeout(() => {
              setCurrentSection(entry.target.id);
            }, 300);
          }
        });
      },
      {
        threshold: [0.6],
        rootMargin: '-40% 0px -40% 0px'
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return currentSection;
};
